import React from "react"

const Circles = ({
  bgUrl,
  thumbnailUrl,
  name,
  textColor,
  menuItems,
  font,
  menuColor,
}) => {
  const menuItem = menuItems.slice(0, 9).map(item => (
    <div
      style={{
        fontSize: "0.8em",
        width: "80px",
        height: "70px",
        margin: "3px",
        marginTop: "30px",
        textAlign: "-webkit-center",
        backgroundColor: menuColor,
      }}
      key={item?.id}
    >
      <div
        style={{
          background: item?.image ? `url("${item?.image?.url}")` : menuColor,
          width: "60px",
          height: "60px",
          backgroundSize: "cover",
          borderRadius: "50%",
          transform: "translate(0px, -20px)",
          border: "1px solid white",
          backgroundPosition: "center",
        }}
      ></div>
      <span
        style={{
          color: textColor,
          fontFamily: font,
          fontWeight: "bold",
          transform: "translate(0px, -15px)",
          display: "inline-block",
        }}
      >
        {item?.label}
      </span>
    </div>
  ))

  return (
    <div
      style={{
        backgroundImage: bgUrl,
        width: "105%",
        height: "105%",
        backgroundSize: "cover",
        marginLeft: "-5px",
        backgroundPosition: "center center",
        textAlign: "center",
        boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 40%)",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "35%",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "80%",
            marginTop: "30px",
            marginLeft: "20px",
            height: "30%",
            backgroundImage: thumbnailUrl,
            position: "absolute",
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        />
      </div>
      <div
        style={{
          paddingTop: "10px",
          flexWrap: "wrap",
          flexDirection: "row",
          justifyContent: "space-evenly",
          display: "flex",
          marginBottom: "10px",
        }}
      >
        {menuItem}
      </div>
    </div>
  )
}

export default Circles
